import GenericStateNoActionBlock from './GenericStateNoActionBlock';
import { GenericStateNoActionBlockProps, GenericStateNoActionBlockValueProps } from './types';

export type { GenericStateNoActionBlockProps, GenericStateNoActionBlockValueProps };
export default GenericStateNoActionBlock;
